import _extends from "@babel/runtime/helpers/extends";
import React, { useRef, useEffect } from 'react';
// import tryLineHeightFixer from './tryLineHeightFixer'
import fixSingleSection from '../texts/NewLHF';
function fix(textsContainer) {
  if (!textsContainer) {
    console.log('LHF RETURN !textsContainer');
    return;
  }
  try {
    // hideEmptySections(textsContainer)
    fixSections(textsContainer);
  } catch (err) {
    console.log('LHF ERROR fixSections');
    console.error(err);
  }
  console.log('LHF FIX END');
}
function fixSections(textsContainer) {
  const sections = getSections(textsContainer);
  sections.forEach(fixSingleSection);
}
function getSections(textsContainer) {
  const x = textsContainer.querySelectorAll('.section');
  return Array.from(x);
}
const runLineHeightFixer = currentContainer => {
  return fix(currentContainer.current);
};
const MasterInfoElement = props => {
  const masterInfoConfig = props.masterInfoConfig,
    CompsMap = props.CompsMap,
    shouldControlHorizontalAlignment = props.shouldControlHorizontalAlignment,
    actions = props.actions;
  const container = useRef(null);
  useEffect(() => {
    runLineHeightFixer(container); // waiting for wix inline styles to take affect
  }, [masterInfoConfig]);
  const master = createMasterInfo(masterInfoConfig, CompsMap, shouldControlHorizontalAlignment, actions);
  const style = {
    paddingLeft: masterInfoConfig.paddingLeft,
    paddingRight: masterInfoConfig.paddingRight,
    paddingTop: masterInfoConfig.paddingTop,
    paddingBottom: masterInfoConfig.paddingBottom,
    boxSizing: 'border-box',
    height: '100%'
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: container,
    style: style
  }, master);
};
const Section = props => {
  const justifyContent = {
    top: 'flex-start',
    middle: 'center',
    bottom: 'flex-end'
  }[props.position];
  const innerStyle = {
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    /* border: 'solid blue 3px', */
    justifyContent
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "section " + props.position,
    style: innerStyle
  }, /*#__PURE__*/React.createElement("div", null, props.children));
};
const Aligner = props => {
  const horizontalAlignmentClass = props.horizontalAlignment.toLowerCase();
  const style = {
    display: 'flex',
    // textAlign: props.horizontalAlignment as 'left' | 'right' | 'center',
    // justifyContent: horizontalAlignmentClass,
    paddingBottom: props.paddingBottom + "px"
  };
  return /*#__PURE__*/React.createElement("div", {
    className: horizontalAlignmentClass,
    style: style
  }, props.children);
};
function SingleInfo(props) {
  const InfoClass = props.InfoClass,
    infoParams = props.infoParams,
    actions = props.actions;
  return /*#__PURE__*/React.createElement(Aligner, {
    horizontalAlignment: infoParams.horizontalAlignment
  }, /*#__PURE__*/React.createElement(InfoClass, _extends({}, infoParams, {
    isNewInfoElements: true,
    shouldControlHorizontalAlignment: props.shouldControlHorizontalAlignment,
    horizontalAlignment: infoParams.horizontalAlignment,
    internalOrExternal: props.internalOrExternal,
    paddingBottom: infoParams.paddingBottom,
    paddingTop: infoParams.paddingTop,
    paddingLeft: infoParams.paddingLeft,
    paddingRight: infoParams.paddingRight,
    actions: actions
  })));
}
/* Icons: {CompClass: InfoIcons, pathForData: 'iconsParams'}, */
function createSection(orderList, masterInfoConfig, CompsMap, shouldControlHorizontalAlignment, actions) {
  const handlerRender = function (x) {
    const infoParams = masterInfoConfig[x.pathInData];
    return /*#__PURE__*/React.createElement(SingleInfo, {
      InfoClass: x.comp,
      key: x.pathInData,
      infoParams: infoParams,
      internalOrExternal: masterInfoConfig.masterType,
      shouldControlHorizontalAlignment: shouldControlHorizontalAlignment,
      actions: actions
    });
  };
  return orderList.filter(x => masterInfoConfig.enabled[x]).map(x => CompsMap[x]).map(handlerRender);
}
function createRealSection(sName, masterInfoConfig, CompsMap, shouldControlHorizontalAlignment, actions) {
  const orderList = masterInfoConfig.order[sName];
  const rendererComps = createSection(orderList, masterInfoConfig, CompsMap, shouldControlHorizontalAlignment, actions);
  const style = {};
  if (rendererComps.length === 0) {
    style.display = 'none';
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error
    React.createElement(Section, {
      key: sName,
      position: sName,
      style: style
    }, rendererComps)
  );
}
function createMasterInfo(masterInfoConfig, CompsMap, shouldControlHorizontalAlignment, actions) {
  /* const masterInfoConfig = config[masterInfoName] */
  const top = 'top';
  const middle = 'middle';
  const bottom = 'bottom';
  const sections = [top, middle, bottom].map(x => createRealSection(x, masterInfoConfig, CompsMap, shouldControlHorizontalAlignment, actions));
  const gridStyle = {
    display: 'grid',
    height: '100%'
    /* gridAutoRows: '1fr', */
  };

  const classes = ['parent'];
  if (masterInfoConfig.masterType === 'internal') {
    classes.push('hover-info-element');
  }
  return /*#__PURE__*/React.createElement("div", {
    key: masterInfoConfig.masterType,
    className: classes.join(' '),
    style: gridStyle
  }, sections);
}
export { MasterInfoElement };
//# sourceMappingURL=MasterInfoElement.js.map